import styled from 'styled-components';

import { TranslatedText } from '@dreryk/react-common';
import { Header, MarginPosition, TestableComponentProps } from '@dreryk/react-components';

const StyledStatisticsHeader = styled(Header)`
   margin-bottom: 18px;
`;
StyledStatisticsHeader.displayName = 'StyledStatisticsHeader';

type StatisticsHeaderProps = TestableComponentProps & {
   readonly text: TranslatedText | string;
};

export const StatisticsHeader = (props: StatisticsHeaderProps): JSX.Element => {
   return (
      <StyledStatisticsHeader margin={MarginPosition.NONE} testId={props.testId}>
         {props.text}
      </StyledStatisticsHeader>
   );
};
